import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

interface Data {
  data: {
    url: string;
    name: string;
    expiry: string;
  };
}

interface Variables {
  id: string;
}

const QUERY = gql`
  query getCompanyFileMetadataById($id: ID!) {
    data: getCompanyFileMetadataById(id: $id) {
      url
      name
      expiry
    }
  }
`;

export const useCompanyFileMetadataQuery = (
  options?: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> =>
  useQuery<Data, Variables>(QUERY, options);
